/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let chatRoomCreatedUrl = root.chatRoomCreateUrl.link;
let UserChatListUrl = root.userChatListUrl.link;
let NormalUserChatListUrl = root.normalUserChatListUrl.link;
let UserChatDetailsUrl = root.userChatDetailsUrl.link;
let AdminChatDetailsUrl = root.adminChatDetailsUrl.link;
let ChatConnectionRequestUrl = root.chatConnectionRequestUrl.link;
let MsgReadStatusUrl = root.msgReadStatusUrl.link;
let NormalOrgListUrl = root.normalOrgListUrl.link;
let ApporveChatRequestUrl = root.apporveChatRequestUrl.link;
let NormalChatListUrl = root.normalChatListUrl.link;
let OrgConnectionReqListUrl = root.orgConnectionReqListUrl.link;
let UserChatReqListUrl = root.userChatReqListUrl.link;
let UploadMsgFileUrl = root.uploadMsgFileUrl.link;
let RequestApprovedURl =  root.requestApprovedUrl.link;
let ChatBrowserNotificationtUrl =  root.chatBrowserNotificationtUrl.link;
let userSearchForChatURL =  root.userSearchForChatUrl.link;
let roomMeetingIdValidURL =  root.roomMeetingIdValidUrl.link;

import Vue from 'vue'
export default {
  state: {
    userChatListState:{},
    normalUserChatListState:{},
    getUserChatDetailsState:{},
    chatConnectionRequestListState:{},
    normalUserOrgListState:{},
    orgConnectionReqListState:{},
    userChatRequestListState:{},
    getUserListByOrgState:{},
    ChatBrowserNotificationtState:{}
  },
  mutations: {
    userChatListMut(state, value) {
      Vue.set(state, 'userChatListState', value);
    },
    normalUserChatListMut(state, value) {
      Vue.set(state, 'normalUserChatListState', value);
    },
    getUserChatDetailsMut(state, value) {
      Vue.set(state, 'getUserChatDetailsState', value);
    },
    chatConnectionRequestListMut(state, value) {
      Vue.set(state, 'chatConnectionRequestListState', value);
    },
    normalUserOrgListMut(state, value) {
      Vue.set(state, 'normalUserOrgListState', value);
    },
    orgConnectionReqListMut(state, value) {
      Vue.set(state, 'orgConnectionReqListState', value);
    },
    userChatRequestListMut(state, value) {
      Vue.set(state, 'userChatRequestListState', value);
    },
    getUserListByOrgMut(state, value) {
      Vue.set(state, 'getUserListByOrgState', value);
    },
    ChatBrowserNotificationtMuatation(state, value){
      Vue.set(state, 'ChatBrowserNotificationtState', value);
    },
  },
  actions: {
    // Get Chat Room Create
    chatRoomCreatedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(chatRoomCreatedUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get User Chat List Create
    adminChatListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(UserChatListUrl, payload).then((res) => {
          context.commit('userChatListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get Admin Chat List Create
    getAdminChatDetailsByIdFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(AdminChatDetailsUrl + payload.id + '/', payload).then((res) => {
          context.commit('getUserChatDetailsMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User Chat List Create
    getUserChatDetailsByIdFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(UserChatDetailsUrl + payload.id + '/', payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // MSg Read Status Function
    msgReadStatusFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(MsgReadStatusUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // MSg Read Status Function
    chatConnectionRequestListFun(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(ChatConnectionRequestUrl, payload).then((res) => {
            context.commit('chatConnectionRequestListMut', res.data);
            resolve(res);
          }).catch((err)=>{
            reject(err);
          })
        })
    },
    // MSg Read Status Function
    SendChatConnectionRequestFun(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(ChatConnectionRequestUrl, payload).then((res) => {
            resolve(res);
          }).catch((err)=>{
            reject(err);
          })
        })
    },
    // Get User Chat List Create
    normalUserChatListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(NormalUserChatListUrl, payload).then((res) => {
          context.commit('normalUserChatListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User List By Organization Create
    getUserListByOrgFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(NormalUserChatListUrl + payload.id + '/').then((res) => {
          context.commit('getUserListByOrgMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get Normal Chat List Create
    normalChatListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(NormalChatListUrl, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User Chat List Create
    normalUserOrgListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(NormalOrgListUrl, payload).then((res) => {
          context.commit('normalUserOrgListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Confirm Request Status Function
    SendChatConnectionRequestApprovedFun(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(ApporveChatRequestUrl, payload).then((res) => {
            resolve(res);
          }).catch((err)=>{
            reject(err);
          })
        })
    },
    // Get Organization Connection Request List
    orgConnectionReqListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(OrgConnectionReqListUrl + payload.id + '/').then((res) => {
          context.commit('orgConnectionReqListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User Chat Request List
    userChatRequestListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(UserChatReqListUrl + payload.id + '/').then((res) => {
          context.commit('userChatRequestListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Upload Msg File In chat
    uploadMsgFileInChatFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.post(UploadMsgFileUrl, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Chat Request Apporved
    apporvedConnectionRequestFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.patch(RequestApprovedURl + payload.id + '/').then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Browser Notification
    chatBroserNotificationFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(ChatBrowserNotificationtUrl, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // User Search For Chat
    userSearchForNewChatFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.post(userSearchForChatURL, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Room Valid Id 
    checkRoomValidIdFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.post(roomMeetingIdValidURL, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
  },
  getters: {
    userChatListGetters: state => state.userChatListState,
    normalUserChatListGetters: state => state.normalUserChatListState,
    getUserChatDetailsGetters :state => state.getUserChatDetailsState,
    chatConnectionRequestListGetters: state => state.chatConnectionRequestListState,
    normalUserOrgListGetter: state => state.normalUserOrgListState,
    orgConnectionReqListGetters: state => state.orgConnectionReqListState,
    userChatRequestListGetters: state => state.userChatRequestListState,
    getUserListByOrgGetters: state => state.getUserListByOrgState,
    ChatBrowserNotificationtGetters: state => state.ChatBrowserNotificationtState
  }
}